import UserFavoriteErrorsFactory from '../Errors/factory.js'
import {UnsubscribeUserFavoriteRequestFactory} from './UnsubscribeUserFavoriteRequestFactory.js'

export class UserFavoriteRequestsFactory {
  static unsubscribeUserFavoriteRequestFactory = ({adId, token, userId}) => {
    UnsubscribeUserFavoriteRequestFactory.validate({
      adId,
      token,
      userId,
      unsubscribeFavoriteUserError: UserFavoriteErrorsFactory.unsubscribeFavoriteUserError
    })
    return new UnsubscribeUserFavoriteRequestFactory({adId, token, userId})
  }
}
